module.exports = __webpack_public_path__ + "static/media/Attic.2c0de941.mp3";